<rl-resource
  [bibliographicResource]="bibliographicResource"
  [currentUserPermissions]="currentUserPermissions"
  [resourceEditUrl]="resourceEditUrl"
  [resourceExportUrl]="resourceExportUrl"
  [resourceImage]="resourceImage"
  [onlineResource]="googleBookPreview$ | async"
>
</rl-resource>
<rl-lists-for-resource
  [listsForResource]="listsForResource$ | async"
></rl-lists-for-resource>
